<template>
  <div>
    <template v-if="loading">
      <div>
        <img
          src="../../../../assets/img/loader.svg"
          alt="loader"
          class="sa-loader sa-loader-top"
        />
      </div>
    </template>
    <template v-else>
      <div class="sa-mob-cont">
        <button class="sa-btn-back" @click="$parent.selectDoctorFlag = false">
          <i class="icon-arrow-left"></i>
        </button>
        <div class="sa-mob-cont-padbt">
          <div class="sa-row">
            <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
              <div class="sa-form-group">
                <input
                  v-model="searchName"
                  type="text"
                  id="searchName"
                  name="Search Name"
                  class="sa-form-control sa-form-control-lg"
                  @input="getDoctors"
                  placeholder="Search Doctor"
                /><i class="icon-search sa-search"></i>
              </div>
            </div>
          </div>
          <ul class="sa-doc-list">
            <li
              @click="doctorDetails(doctor)"
              v-for="(doctor, index) in doctorList"
              :key="index"
            >
              <figure class="sa-avtar sa-avtar-xs">
                <img
                  :src="doctor.img ? doctor.img : unknownImg"
                  alt="Doctor"
                  class="sa-img-cover"
                />
              </figure>
              <h6>
                {{ doctor.title_nm }} {{ doctor.name }}
                <small v-if="doctor.class_nm == doctor.splst_name">{{
                  doctor.splst_name
                }}</small>
                <small v-else-if="doctor.class_nm"
                  >{{ doctor.class_nm }},{{ doctor.splst_name }}</small
                >
                <small v-else>{{ doctor.splst_name }}</small>
              </h6>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
import _ from "lodash";
export default {
  data() {
    return {
      loading: false,
      unknownImg: "https://img.litedev.com/images/unknown-avtar.png",
      doctorList: [],
      searchName: "",
    };
  },
  mounted() {
    this.getDoctors();
  },
  props: ["dept_id", "stid"],
  methods: {
    getDoctors: function () {
      let _self = this;
      if (!_self.searchName) {
        _self.loading = true;
      }
      let userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/employees`,
          body: {
            limit: 1000,
            page: 1,
            dept_id: _self.dept_id,
            stid: _self.stid,
            name: _self.searchName,
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.data && response.data.data) {
            response.data.data = _.remove(response.data.data, (e) => {
              return e.uid != userInfo.uid;
            });
            _self.doctorList = response.data.data;
          } else {
            _self.doctorList = [];
          }
        });
    },
    doctorDetails(doctor) {
      let _self = this;
      _self.loading = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/doctorDetails`,
          body: {
            uid: doctor.uid,
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.data) {
            _self.$parent.viewDoctor = true;
            _self.$parent.doctorInfo = response.data;
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg:
                "Something went wrong. Please try again or contact operations team",
              class: "sa-a-danger",
            });
          }
        });
    },
  },
};
</script>
